import type { RouteLocationAsRelative } from 'vue-router'

export const dashboardRoutes = {
  dashboard: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/'> => ({
    name: '/(app)/[org]/',
    params: { org },
  }),
}
